'use strict';

var _ = require('lodash');

module.exports = {
  template: require('./template.html'),
  computed: _.extend({
    datasets: function() {
      return this.$store.getters.storage.datasets;
    }
  }),
  components: {
    listItem: require('./list-item')
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/scripts/application/components/application-area/datasets/index.js
// module id = 157
// module chunks = 0